import React, { useEffect, useState } from "react";
import "../../styles/pages/storyboard/add.scss";
import axios from "axios";
import "react-month-picker-input/dist/react-month-picker-input.css";
import { useAuth0 } from "@auth0/auth0-react";
import "chartjs-adapter-moment";
import { useEnv } from "../../context/env.context";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faComment,
  faTimes,
  faVideo,
} from "@fortawesome/free-solid-svg-icons";
import { Analytics } from "../../hooks/analytics";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import Logo from "../../images/logo.png";
import Mark from "../../images/marking-black.png";

import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import htmlToDraft from "html-to-draftjs";
import moment from "moment";
import CopyToClipboard from "react-copy-to-clipboard";
export const StoryboardAdd = (props) => {
  const { getAccessTokenSilently } = useAuth0();
  const [me, setMe] = useState(null);
  const { apiServerUrl } = useEnv();
  const [story, setStory] = useState({
    type: "text",
    shareType: "email",
  });
  const history = useHistory();
  const [emailSent, setEmailSent] = useState(false);
  const [photo, setPhoto] = useState(null);
  const [step, setStep] = useState(1);
  const [HTML, setHTML] = useState("");
  const [error, setError] = useState(false);
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  const [cardType, setCardType] = useState("white");
  const [noRecording, setNoRecording] = useState(false);
  const [noVideo, setNoVideo] = useState(true);
  const [shareType, setShareType] = useState("email");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    getMe();
    const nav = document.getElementsByClassName("nav-bar__container")[0];
    if (nav) {
      nav.style = "display:none";
    }
    const isVideoaskMessage = (message) =>
      message.origin === "https://www.videoask.com" &&
      message.data &&
      message.data.type &&
      message.data.type.startsWith("videoask_");

    function handler(message) {
      if (!isVideoaskMessage(message)) {
        return;
      }

      if (message.data.type === "videoask_question_submitted") {
        setTimeout(() => {
          getStory(true);
        }, 3000);
        setNoRecording(true);
        Analytics("Recorded Video Story");
      }
    }

    window.addEventListener("message", handler);

    return () => {
      window.removeEventListener("message", handler);
      const nav = document.getElementsByClassName("nav-bar__container")[0];
      if (nav) {
        nav.style = "display:flex";
      }
    };
  }, [story]);

  const getStory = async (recheck = true) => {
    const token = await getAccessTokenSilently();
    const config = {
      url: `${apiServerUrl}/api/story/${story.claimUrl}`,
      method: "GET",
      headers: {
        "content-type": "application/json",
      },
    };
    config.headers = {
      Authorization: `Bearer ${token}`,
    };
    const response = await axios(config);

    if (recheck) {
      if (!response.data.story.mediaUrl) {
        setTimeout(() => {
          getStory(true);
        }, 3000);
      } else {
        setNoVideo(false);
        const newStory = { ...story, mediaUrl: response.data.story.mediaUrl };
        setStory(newStory);
      }
    }
  };

  const sendInvite = async () => {
    const token = await getAccessTokenSilently();

    let body = {
      email: story.email,
      text: story.personalNote,
    };

    const config = {
      url: `${apiServerUrl}/api/story/invite/${story.id}`,
      method: "POST",
      data: body,
      headers: {
        "content-type": "application/json",
      },
    };
    config.headers = {
      Authorization: `Bearer ${token}`,
    };

    try {
      const story = await axios(config);
      Analytics("Sent Story Invite");
      setEmailSent(true);
    } catch (error) {
      console.log(error);
      alert("Couldn't send email, please try again");
    }
  };

  const getMe = async () => {
    const token = await getAccessTokenSilently();

    const config = {
      url: `${apiServerUrl}/api/users/me`,
      method: "GET",
      headers: {
        "content-type": "application/json",
      },
    };
    config.headers = {
      Authorization: `Bearer ${token}`,
    };
    try {
      const response = await axios(config);

      if (response.data) {
        setMe(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const saveTextStory = async () => {
    const token = await getAccessTokenSilently();

    setError(false);

    let body = {
      firstName: story.firstName,
      lastName: story.lastName,
      sub: me.sub,
      text: HTML,
      type: "text",
      backgroundType: cardType,
    };

    const config = {
      url: `${apiServerUrl}/api/story`,
      method: "POST",
      data: body,
      headers: {
        "content-type": "application/json",
      },
    };
    config.headers = {
      Authorization: `Bearer ${token}`,
    };
    const savedStory = await axios(config);

    savedStory.data.type = story.type;
    setStory(savedStory.data);

    Analytics("Saved Story");
  };

  const saveVideoStory = async () => {
    const token = await getAccessTokenSilently();

    setError(false);

    let body = {
      firstName: story.firstName,
      lastName: story.lastName,
      sub: me.sub,
      type: "video",
    };

    const config = {
      url: `${apiServerUrl}/api/story`,
      method: "POST",
      data: body,
      headers: {
        "content-type": "application/json",
      },
    };
    config.headers = {
      Authorization: `Bearer ${token}`,
    };
    const savedStory = await axios(config);

    savedStory.data.type = story.type;
    savedStory.data.firstName = story.firstName;
    savedStory.data.lastName = story.lastName;
    setStory(savedStory.data);

    Analytics("Saved Story");
  };

  // const uploadAvatar = async (files) => {
  //   const token = await getAccessTokenSilently();
  //   const file = files[0];
  //   let data = new FormData();
  //   data.append("file", file, file.name);
  //   let URL = `${apiServerUrl}/api/highlights/upload`;
  //   const upload = await axios.post(URL, data, {
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //       "Content-Type": "multipart/form-data",
  //     },
  //   });
  //   console.log(upload);
  //   setPhoto(upload.data.avatar);
  // };

  return (
    <div className="addStory">
      <div className="white-background">
        <div className="form">
          {step === 1 && (
            <div className="left">
              <div className="title">
                <FontAwesomeIcon
                  onClick={() => {
                    history.push("/storyboard");
                  }}
                  className="close"
                  icon={faTimes}
                />
                <h2>Compose Your Story</h2>
              </div>
              <div className="form-group split">
                <label htmlFor="type">
                  Who do you want to send a story to? <span>Required</span>
                </label>
                <input
                  placeholder="First Name"
                  type="text"
                  onChange={(event) => {
                    setStory({ ...story, firstName: event.target.value });
                  }}
                  value={story.firstName}
                  name="type"
                  id="type"
                />
                <input
                  placeholder="Last Name"
                  type="text"
                  onChange={(event) => {
                    setStory({ ...story, lastName: event.target.value });
                  }}
                  value={story.lastName}
                  name="type"
                  id="type"
                />
              </div>
              <div className="form-group buttonGroup">
                <label htmlFor="type">
                  Select the kind of story you want to send:{" "}
                  <span>Required</span>
                </label>
                <button
                  className={`${story.type === "text" ? "active" : ""}`}
                  onClick={() => {
                    const newStory = { ...story, type: "text" };
                    setStory(newStory);
                  }}
                >
                  <FontAwesomeIcon icon={faComment} /> Text
                </button>
                <button
                  className={`${story.type === "video" ? "active" : ""}`}
                  onClick={() => {
                    const newStory = { ...story, type: "video" };
                    setStory(newStory);
                  }}
                >
                  <FontAwesomeIcon icon={faVideo} /> Video
                </button>
              </div>
              <div className="steps">
                <div className={`step ${step === 1 ? "active" : ""}`}>
                  <span className="number">1</span>
                </div>
                <div className={`step ${step === 2 ? "active" : ""}`}>
                  <span className="number">2</span>
                </div>
                <div className={`step ${step === 3 ? "active" : ""}`}>
                  <span className="number">3</span>
                </div>
              </div>

              <div className="buttonActions">
                <button
                  className="btn secondary"
                  type="button"
                  onClick={async () => {
                    history.push("/storyboard");
                  }}
                >
                  Discard
                </button>
                <button
                  className="btn primary"
                  disabled={!story.firstName || !story.lastName}
                  type="button"
                  onClick={async () => {
                    if (story.type === "video") {
                      await saveVideoStory();
                    }
                    setStep(2);
                  }}
                >
                  Continue
                </button>
              </div>
            </div>
          )}
          {step === 2 && story.type === "video" && (
            <div className="left">
              <div className="title">
                <FontAwesomeIcon
                  onClick={() => {
                    history.push("/storyboard");
                  }}
                  className="close"
                  icon={faTimes}
                />
                <h2>Compose Your Story</h2>
              </div>
              <div className="form-group split">
                <label htmlFor="type">
                  Who do you want to send a story to? <span>Required</span>
                </label>
                <input
                  placeholder="First Name"
                  type="text"
                  onChange={(event) => {
                    setStory({ ...story, firstName: event.target.value });
                  }}
                  value={story.firstName}
                  name="type"
                  id="type"
                />
                <input
                  placeholder="Last Name"
                  type="text"
                  onChange={(event) => {
                    setStory({ ...story, lastName: event.target.value });
                  }}
                  value={story.lastName}
                  name="type"
                  id="type"
                />
              </div>
              <div className="form-group buttonGroup">
                <label htmlFor="type">
                  Select the kind of story you want to send:{" "}
                  <span>Required</span>
                </label>
                <button
                  className={`${story.type === "text" ? "active" : ""}`}
                  onClick={() => {
                    const newStory = { ...story, type: "text" };
                    setStory(newStory);
                  }}
                >
                  <FontAwesomeIcon icon={faComment} /> Text
                </button>
                <button
                  className={`${story.type === "video" ? "active" : ""}`}
                  onClick={() => {
                    const newStory = { ...story, type: "video" };
                    setStory(newStory);
                  }}
                >
                  <FontAwesomeIcon icon={faVideo} /> Video
                </button>
              </div>
              <div className="steps">
                <div className={`step ${step === 1 ? "active" : ""}`}>
                  <span className="number">1</span>
                </div>
                <div className={`step ${step === 2 ? "active" : ""}`}>
                  <span className="number">2</span>
                </div>
                <div className={`step ${step === 3 ? "active" : ""}`}>
                  <span className="number">3</span>
                </div>
              </div>

              <div className="buttonActions">
                <button
                  className="btn secondary"
                  type="button"
                  onClick={async () => {
                    history.push("/storyboard");
                  }}
                >
                  Discard
                </button>
                <button
                  className="btn primary"
                  disabled={!story.mediaUrl}
                  type="button"
                  onClick={async () => {
                    setStep(3);
                  }}
                >
                  Continue
                </button>
              </div>
            </div>
          )}
          {step === 2 && story.type === "text" && (
            <div className="left">
              <div className="title">
                <FontAwesomeIcon
                  onClick={() => {
                    history.push("/storyboard");
                  }}
                  className="close"
                  icon={faTimes}
                />
                <h2>Compose Your Story</h2>
              </div>
              <div className="form-group">
                <label htmlFor="type">
                  Compose your story <span>Required</span>
                </label>

                <Editor
                  handlePastedText={() => false}
                  onEditorStateChange={(e) => {
                    setEditorState(e);
                    let raw = convertToRaw(e.getCurrentContent());
                    let html = draftToHtml(raw);
                    setHTML(html);
                  }}
                  editorState={editorState}
                />
              </div>
              <div
                style={{
                  marginTop: "60px",
                }}
                className="form-group"
              >
                <label htmlFor="type">
                  Choose a background <span>Required</span>
                </label>

                <div className="backgrounds">
                  <div
                    onClick={() => {
                      setCardType("white");
                    }}
                    className={`background white ${
                      cardType === "white" ? "active" : ""
                    }`}
                  ></div>
                  <div
                    onClick={() => {
                      setCardType("yellow");
                    }}
                    className={`background yellow ${
                      cardType === "yellow" ? "active" : ""
                    }`}
                  ></div>
                  <div
                    onClick={() => {
                      setCardType("orange");
                    }}
                    className={`background orange ${
                      cardType === "orange" ? "active" : ""
                    }`}
                  ></div>
                  <div
                    onClick={() => {
                      setCardType("blue");
                    }}
                    className={`background blue ${
                      cardType === "blue" ? "active" : ""
                    }`}
                  ></div>
                </div>
              </div>
              <div className="steps">
                <div
                  onClick={() => {
                    setStep(1);
                  }}
                  className={`step ${step === 1 ? "active" : ""}`}
                >
                  <span className="number">1</span>
                </div>
                <div className={`step ${step === 2 ? "active" : ""}`}>
                  <span className="number">2</span>
                </div>
                <div className={`step ${step === 3 ? "active" : ""}`}>
                  <span className="number">3</span>
                </div>
              </div>

              <div className="buttonActions">
                <button
                  className="btn secondary"
                  type="button"
                  onClick={async () => {
                    history.push("/storyboard");
                  }}
                >
                  Discard
                </button>
                <button
                  className="btn primary"
                  disabled={!HTML || HTML == "<p></p>\n" || !cardType}
                  type="button"
                  onClick={async () => {
                    if (story.type === "text") {
                      await saveTextStory();
                    }
                    setStep(3);
                  }}
                >
                  Continue
                </button>
              </div>
            </div>
          )}
          {step === 3 && !emailSent && (
            <div className="left">
              <div className="title">
                <FontAwesomeIcon
                  onClick={() => {
                    history.push("/storyboard");
                  }}
                  className="close"
                  icon={faTimes}
                />
                <h2>Compose Your Story</h2>
              </div>

              <div className="content">
                <div className="form-group">
                  <label>How would you like to send your story?</label>
                  <div className="group">
                    <h4
                      className={`${shareType === "email" ? "active" : ""}`}
                      onClick={() => {
                        setShareType("email");
                      }}
                    >
                      Email
                    </h4>
                    <h4
                      className={`${shareType === "link" ? "active" : ""}`}
                      onClick={() => {
                        setShareType("link");
                      }}
                    >
                      Share a link
                    </h4>
                  </div>
                </div>

                <div className="form-group">
                  <label>Add a personal node (optional)</label>
                  <textarea
                    onChange={(e) => {
                      setStory({ ...story, personalNote: e.target.value });
                    }}
                    placeholder="E.g Hey Allison, I'm doing some career exploration and could use your perspective! Thank you so much."
                  />
                </div>

                {shareType === "link" && (
                  <div className="form-group copy">
                    <label>Ready to share?</label>
                    <div className="link">
                      <CopyToClipboard
                        text={`${story.personalNote} ${window.location.origin}/story/${story.claimUrl}`}
                        onCopy={() => {
                          setCopied(true);
                          setTimeout(() => {
                            setCopied(false);
                          }, 5000);
                        }}
                      >
                        <div>
                          {!copied && (
                            <button className="btn primary">
                              Copy Shareable Link
                            </button>
                          )}
                          {copied && (
                            <button className="btn primary">Copied!</button>
                          )}
                        </div>
                      </CopyToClipboard>
                    </div>
                  </div>
                )}

                {shareType === "email" && (
                  <div className="form-group">
                    <label>Just add their email and click send!</label>
                    <input
                      type="text"
                      onChange={(e) => {
                        setStory({ ...story, email: e.target.value });
                      }}
                      placeholder="email@domain.com"
                    />
                  </div>
                )}
              </div>

              <div className="steps">
                <div
                  onClick={() => {
                    setStep(1);
                  }}
                  className={`step ${step === 1 ? "active" : ""}`}
                >
                  <span className="number">1</span>
                </div>
                <div
                  onClick={() => {
                    setStep(2);
                  }}
                  className={`step ${step === 2 ? "active" : ""}`}
                >
                  <span className="number">2</span>
                </div>
                <div className={`step ${step === 3 ? "active" : ""}`}>
                  <span className="number">3</span>
                </div>
              </div>

              <div className="buttonActions">
                <button
                  className="btn secondary"
                  type="button"
                  onClick={async () => {
                    history.push("/storyboard");
                  }}
                >
                  Discard
                </button>
                {shareType === "email" && (
                  <button
                    className="btn primary"
                    disabled={!story.email || !shareType}
                    type="button"
                    onClick={async () => {
                      await sendInvite();
                    }}
                  >
                    Continue
                  </button>
                )}
                {shareType === "link" && (
                  <button
                    className="btn primary"
                    disabled={false}
                    type="button"
                    onClick={async () => {
                      history.push("/storyboard");
                    }}
                  >
                    Finished
                  </button>
                )}
              </div>
            </div>
          )}

          {step === 3 && emailSent && (
            <div className="left">
              <div className="title">
                <FontAwesomeIcon
                  onClick={() => {
                    history.push("/storyboard");
                  }}
                  className="close"
                  icon={faTimes}
                />
                <h2>Compose Your Story</h2>
              </div>

              <div className="content success">
                <h3>
                  <FontAwesomeIcon icon={faCheck} /> Story sent successfully!
                </h3>
                <p>Do you want to send another story?</p>
                <button
                  className="btn blank"
                  onClick={() => {
                    setStep(1);
                    setEmailSent(false);
                    setStory({
                      type: "text",
                      shareType: "email",
                    });
                    setHTML("");
                    setEditorState(EditorState.createEmpty());
                  }}
                >
                  Send Another
                </button>
              </div>

              <div className="steps">
                <div
                  onClick={() => {
                    setStep(1);
                  }}
                  className={`step ${step === 1 ? "active" : ""}`}
                >
                  <span className="number">1</span>
                </div>
                <div
                  onClick={() => {
                    setStep(2);
                  }}
                  className={`step ${step === 2 ? "active" : ""}`}
                >
                  <span className="number">2</span>
                </div>
                <div className={`step ${step === 3 ? "active" : ""}`}>
                  <span className="number">3</span>
                </div>
              </div>

              <div className="buttonActions">
                <button
                  className="btn secondary"
                  type="button"
                  onClick={async () => {
                    history.push("/storyboard");
                  }}
                >
                  Discard
                </button>
                <button
                  className="btn primary"
                  disabled={false}
                  type="button"
                  onClick={async () => {
                    history.push("/storyboard");
                  }}
                >
                  Finished
                </button>
              </div>
            </div>
          )}

          {step === 1 && (
            <div className="right">
              <div className="white-background">
                <div className={`preview ${cardType}`}>
                  <h5>Preview</h5>
                  <div className="highlightArea">
                    <div className="highlightMoment">
                      {HTML && (
                        <div
                          className="content"
                          dangerouslySetInnerHTML={{ __html: HTML }}
                        />
                      )}
                      {!HTML && (
                        <div className="content">
                          <p>Your message will appear here...</p>
                        </div>
                      )}
                      <div className="bottomArea">
                        <img src={me?.avatar} alt="avatar" />
                        <div className="info">
                          <h4>
                            {me?.first_name} {me?.last_name}
                          </h4>
                          <h5>{moment().format("MMMM DD, YYYY")}</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {step === 2 && story.type === "text" && (
            <div className="right">
              <div className="white-background">
                <div className={`preview ${cardType}`}>
                  <h5>Preview</h5>
                  <div className="highlightArea">
                    <div className="highlightMoment">
                      {HTML && (
                        <div
                          className="content"
                          dangerouslySetInnerHTML={{ __html: HTML }}
                        />
                      )}
                      {!HTML && (
                        <div className="content">
                          <p>Your message will appear here...</p>
                        </div>
                      )}
                      <div className="bottomArea">
                        <img src={me?.avatar} alt="avatar" />
                        <div className="info">
                          <h4>
                            {me?.first_name} {me?.last_name}
                          </h4>
                          <h5>{moment().format("MMMM DD, YYYY")}</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {step === 2 && story.type === "video" && noVideo && (
            <div className="right">
              <div className="white-background">
                <div className={`preview ${cardType}`}>
                  <h5>Record Your Video</h5>
                  {!noRecording && (
                    <iframe
                      style={{
                        width: "100%",
                        height: "600px",
                        margin: "0px auto",
                        display: "block",
                      }}
                      title={"Story"}
                      src={`https://www.videoask.com/${process.env.REACT_APP_STORYID}#story_id=${story.id}`}
                      allow="camera *; microphone *; autoplay *; encrypted-media *; fullscreen *; display-capture *;"
                    ></iframe>
                  )}
                  {noRecording && (
                    <div className="waiting">
                      <lottie-player
                        src="https://assets6.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
                        background="transparent"
                        speed="1"
                        style={{
                          width: "300px",
                          height: "300px",
                          margin: "0 auto",
                        }}
                        loop
                        autoplay
                      ></lottie-player>
                      <h3
                        style={{
                          color: "#000",
                        }}
                      >
                        Your story is almost uploaded!
                      </h3>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          {step === 2 && story.type === "video" && !noVideo && (
            <div className="right">
              <div className="white-background">
                <div className="preview">
                  <div className="highlightArea">
                    <svg
                      width="154"
                      height="141"
                      viewBox="0 0 154 141"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17 20.9688C17.0417 21.5104 16.9792 21.9583 16.8125 22.3125C16.6458 22.6667 16.4167 22.9688 16.125 23.2188C15.8333 23.4688 15.5 23.6667 15.125 23.8125C14.75 23.9583 14.3854 24.0938 14.0312 24.2188C13.8646 24.1146 13.6979 24.0104 13.5312 23.9062C13.3854 23.7812 13.2083 23.6875 13 23.625C12.7292 23.125 12.4688 22.6875 12.2188 22.3125C11.9688 21.9167 11.8542 21.4688 11.875 20.9688C11.875 20.9479 11.8854 20.8333 11.9062 20.625C11.9479 20.4167 11.9896 20.1875 12.0312 19.9375C12.0938 19.6875 12.1354 19.4583 12.1562 19.25C12.1979 19.0208 12.2188 18.8958 12.2188 18.875C11.7396 18.9167 11.2396 19.0208 10.7188 19.1875C10.1979 19.3542 9.6875 19.5521 9.1875 19.7812C8.70833 20.0104 8.25 20.2396 7.8125 20.4688C7.39583 20.6979 7.05208 20.8958 6.78125 21.0625C6.78125 21.125 6.73958 21.2812 6.65625 21.5312C6.57292 21.7604 6.46875 22.0104 6.34375 22.2812C6.21875 22.5312 6.08333 22.7604 5.9375 22.9688C5.79167 23.1771 5.64583 23.2812 5.5 23.2812C5.52083 23.3438 5.55208 23.4062 5.59375 23.4688C5.63542 23.5312 5.63542 23.6146 5.59375 23.7188C5.30208 23.8021 5.04167 23.9062 4.8125 24.0312C4.58333 24.1771 4.34375 24.2917 4.09375 24.375C3.84375 24.4792 3.57292 24.5312 3.28125 24.5312C2.98958 24.5312 2.64583 24.4271 2.25 24.2188C2.25 24.0938 2.19792 23.9896 2.09375 23.9062C1.98958 23.8021 1.875 23.7188 1.75 23.6562C1.64583 23.5729 1.55208 23.5104 1.46875 23.4688C1.38542 23.4062 1.34375 23.3542 1.34375 23.3125C1.23958 23.3333 1.19792 23.2604 1.21875 23.0938C1.23958 22.9271 1.32292 22.8854 1.46875 22.9688C1.23958 22.6771 1.09375 22.4271 1.03125 22.2188C0.989583 21.9896 0.875 21.7083 0.6875 21.375C0.729167 21.3333 0.770833 21.2604 0.8125 21.1562C0.833333 21.0521 0.854167 20.9583 0.875 20.875C0.895833 20.7917 0.927083 20.7292 0.96875 20.6875C1.01042 20.6458 1.0625 20.6562 1.125 20.7188C1.08333 20.5312 1.08333 20.375 1.125 20.25C1.16667 20.125 1.20833 20.0104 1.25 19.9062C1.29167 19.8021 1.32292 19.6979 1.34375 19.5938C1.36458 19.4896 1.33333 19.375 1.25 19.25C1.58333 18.7917 1.80208 18.3021 1.90625 17.7812C2.01042 17.2396 2.07292 16.75 2.09375 16.3125C2.23958 16.1667 2.36458 15.9583 2.46875 15.6875C2.59375 15.4167 2.6875 15.1458 2.75 14.875C2.8125 14.5833 2.83333 14.3125 2.8125 14.0625C2.8125 13.7917 2.78125 13.5729 2.71875 13.4062C2.73958 13.3021 2.85417 13.2708 3.0625 13.3125C3.1875 12.625 3.27083 11.8542 3.3125 11C3.375 10.125 3.46875 9.30208 3.59375 8.53125C3.71875 7.73958 3.92708 7.05208 4.21875 6.46875C4.51042 5.86458 4.97917 5.46875 5.625 5.28125C5.75 5.71875 5.90625 6.10417 6.09375 6.4375C6.30208 6.77083 6.52083 7.09375 6.75 7.40625C7 7.69792 7.23958 8 7.46875 8.3125C7.71875 8.625 7.94792 8.97917 8.15625 9.375C8.13542 9.77083 8.09375 10.2292 8.03125 10.75C7.96875 11.2708 7.88542 11.8021 7.78125 12.3438C7.69792 12.8854 7.60417 13.4062 7.5 13.9062C7.41667 14.4062 7.33333 14.8333 7.25 15.1875C7.27083 15.2917 7.32292 15.3542 7.40625 15.375C7.51042 15.3958 7.53125 15.4896 7.46875 15.6562C7.96875 15.5312 8.48958 15.4167 9.03125 15.3125C9.57292 15.2083 10.1146 15.0938 10.6562 14.9688C11.1979 14.8438 11.7188 14.7083 12.2188 14.5625C12.7396 14.3958 13.2188 14.1979 13.6562 13.9688C13.7604 13.1562 13.8958 12.3438 14.0625 11.5312C14.2292 10.7188 14.25 9.88542 14.125 9.03125C14.2292 8.94792 14.3125 8.84375 14.375 8.71875C14.4375 8.59375 14.5417 8.51042 14.6875 8.46875C14.5833 8.07292 14.5417 7.65625 14.5625 7.21875C14.5833 6.78125 14.6562 6.36458 14.7812 5.96875C14.9271 5.57292 15.125 5.23958 15.375 4.96875C15.6458 4.67708 15.9688 4.48958 16.3438 4.40625C16.5729 4.73958 16.7708 5.10417 16.9375 5.5C17.1042 5.875 17.2708 6.26042 17.4375 6.65625C17.625 7.03125 17.8125 7.39583 18 7.75C18.2083 8.08333 18.4688 8.375 18.7812 8.625C18.8438 9.22917 18.8854 9.85417 18.9062 10.5C18.9479 11.1458 18.9792 11.8021 19 12.4688C18.8333 13.2604 18.6458 14.0312 18.4375 14.7812C18.25 15.5104 18.1146 16.2917 18.0312 17.125C17.8854 17.2917 17.7708 17.4792 17.6875 17.6875C17.6042 17.8958 17.5208 18.1146 17.4375 18.3438C17.3542 18.5521 17.2604 18.7604 17.1562 18.9688C17.0521 19.1562 16.9271 19.3229 16.7812 19.4688C16.8646 19.7188 16.875 19.9583 16.8125 20.1875C16.7708 20.3958 16.8333 20.6562 17 20.9688ZM37.0625 6.40625C37.0833 6.55208 37.0833 6.66667 37.0625 6.75C37.0625 6.8125 37.0521 6.875 37.0312 6.9375C37.0312 7 37.0312 7.07292 37.0312 7.15625C37.0312 7.21875 37.0521 7.32292 37.0938 7.46875C36.6562 8.17708 36.1458 8.66667 35.5625 8.9375C35 9.1875 34.3854 9.375 33.7188 9.5C33.0521 9.60417 32.3646 9.71875 31.6562 9.84375C30.9688 9.96875 30.2812 10.2396 29.5938 10.6562C29.3229 10.5521 29.0729 10.5521 28.8438 10.6562C28.6354 10.7604 28.3229 10.7917 27.9062 10.75C27.7812 10.875 27.625 10.9688 27.4375 11.0312C27.25 11.0729 27.0625 11.125 26.875 11.1875C26.9583 11.375 26.9896 11.5729 26.9688 11.7812C26.9688 11.9688 27 12.125 27.0625 12.25C27.7917 12.3125 28.5938 12.3021 29.4688 12.2188C30.3646 12.1354 31.2396 12.0833 32.0938 12.0625C32.1146 12.1667 32.1042 12.2396 32.0625 12.2812C32.0208 12.3021 32.0104 12.3542 32.0312 12.4375C32.1771 12.5417 32.3229 12.6771 32.4688 12.8438C32.6146 12.9896 32.7604 13.1354 32.9062 13.2812C33.0521 13.4271 33.1979 13.5521 33.3438 13.6562C33.5104 13.7396 33.6979 13.7708 33.9062 13.75C33.9896 13.9167 34.0417 14.1042 34.0625 14.3125C34.1042 14.5 34.0833 14.6979 34 14.9062C33.6667 15.1354 33.3333 15.375 33 15.625C32.6667 15.8542 32.3125 16.0625 31.9375 16.25C31.5833 16.4375 31.1979 16.5938 30.7812 16.7188C30.3854 16.8229 29.9375 16.8646 29.4375 16.8438C29.3333 16.8438 29.25 16.8438 29.1875 16.8438C29.1458 16.8438 29.0833 16.8125 29 16.75C28.8333 16.8542 28.5938 16.8854 28.2812 16.8438C27.9896 16.8021 27.7604 16.8333 27.5938 16.9375C27.3646 16.8333 27.0833 16.7917 26.75 16.8125C26.4375 16.8125 26.1562 16.7708 25.9062 16.6875C25.5729 17.125 25.2708 17.5938 25 18.0938C24.7292 18.5938 24.4896 19.125 24.2812 19.6875C24.9896 19.7917 25.5729 19.8333 26.0312 19.8125C26.5104 19.7917 26.9583 19.7604 27.375 19.7188C27.7917 19.6562 28.2188 19.6042 28.6562 19.5625C29.0938 19.5 29.6458 19.4792 30.3125 19.5C30.7292 19.2708 31.2188 19.125 31.7812 19.0625C32.3646 18.9792 32.8958 18.8542 33.375 18.6875C33.5417 18.75 33.6875 18.8646 33.8125 19.0312C33.9375 19.1771 34.0521 19.3229 34.1562 19.4688C34.2812 19.5938 34.4062 19.7083 34.5312 19.8125C34.6562 19.9167 34.8125 19.9583 35 19.9375C35.0833 20.0208 35.1354 20.125 35.1562 20.25C35.1979 20.3542 35.2292 20.4583 35.25 20.5625C35.2708 20.6667 35.3021 20.7604 35.3438 20.8438C35.4062 20.9062 35.5 20.9271 35.625 20.9062C35.3125 21.5938 34.9479 22.125 34.5312 22.5C34.1354 22.8542 33.6771 23.125 33.1562 23.3125C32.6354 23.5 32.0521 23.6458 31.4062 23.75C30.7812 23.8542 30.0833 23.9792 29.3125 24.125C29.125 24.1667 28.9688 24.1562 28.8438 24.0938C28.7188 24.0521 28.5729 24.0312 28.4062 24.0312C27.9271 24.1354 27.3542 24.2292 26.6875 24.3125C26.0208 24.3958 25.3438 24.4271 24.6562 24.4062C23.9688 24.3854 23.3125 24.2917 22.6875 24.125C22.0625 23.9792 21.5521 23.7083 21.1562 23.3125C20.9896 23.1667 20.875 23 20.8125 22.8125C20.7708 22.6042 20.6354 22.4479 20.4062 22.3438C20.3854 22.0729 20.3438 21.7708 20.2812 21.4375C20.2188 21.1042 20.1562 20.7604 20.0938 20.4062C20.0312 20.0312 19.9792 19.6667 19.9375 19.3125C19.9167 18.9583 19.9375 18.6354 20 18.3438C20.0625 18.0312 20.1875 17.75 20.375 17.5C20.5833 17.25 20.6562 16.9792 20.5938 16.6875C20.6979 16.6667 20.7604 16.6146 20.7812 16.5312C20.8021 16.4271 20.8854 16.3854 21.0312 16.4062C21.1562 16.0312 21.2917 15.6771 21.4375 15.3438C21.5833 15.0104 21.7292 14.6875 21.875 14.375C22.0417 14.0625 22.1979 13.75 22.3438 13.4375C22.5104 13.1042 22.6667 12.7396 22.8125 12.3438C22.5208 12.0729 22.3021 11.7812 22.1562 11.4688C22.0312 11.1354 21.9375 10.8125 21.875 10.5C21.8125 10.1667 21.7604 9.83333 21.7188 9.5C21.6771 9.14583 21.6042 8.79167 21.5 8.4375C21.7083 8.125 21.9583 7.875 22.25 7.6875C22.5625 7.47917 22.8958 7.3125 23.25 7.1875C23.6042 7.0625 23.9896 6.95833 24.4062 6.875C24.8229 6.79167 25.2604 6.69792 25.7188 6.59375C26.5521 6.32292 27.2917 6.11458 27.9375 5.96875C28.6042 5.82292 29.25 5.70833 29.875 5.625C30.5208 5.52083 31.1875 5.42708 31.875 5.34375C32.5625 5.26042 33.3438 5.13542 34.2188 4.96875C34.4062 5.15625 34.5833 5.25 34.75 5.25C34.8333 5.0625 34.9271 5.01042 35.0312 5.09375C35.1562 5.15625 35.2083 5.09375 35.1875 4.90625C35.3958 5.26042 35.6562 5.5625 35.9688 5.8125C36.3021 6.04167 36.6667 6.23958 37.0625 6.40625ZM41.0312 20.75C40.8021 21.5833 40.5938 22.2188 40.4062 22.6562C40.2396 23.0729 39.9792 23.5104 39.625 23.9688C39.3542 23.9271 39.1667 23.9583 39.0625 24.0625C38.9583 24.1667 38.8438 24.2604 38.7188 24.3438C38.5312 24.3854 38.3958 24.3854 38.3125 24.3438C38.2292 24.3021 38.1562 24.25 38.0938 24.1875C38.0312 24.1458 37.9479 24.0938 37.8438 24.0312C37.7604 23.9896 37.625 23.9688 37.4375 23.9688C37.3958 23.8021 37.3438 23.6458 37.2812 23.5C37.2396 23.3542 37.1042 23.3021 36.875 23.3438C36.9167 23.1771 36.9271 23.0417 36.9062 22.9375C36.8854 22.8125 36.8542 22.7083 36.8125 22.625C36.7917 22.5208 36.7708 22.4271 36.75 22.3438C36.7292 22.2396 36.7396 22.1146 36.7812 21.9688C36.6771 21.9688 36.5938 21.8958 36.5312 21.75C36.4688 21.6042 36.3958 21.4583 36.3125 21.3125C36.375 20.9375 36.4375 20.5833 36.5 20.25C36.5625 19.9167 36.6354 19.6042 36.7188 19.3125C36.8229 19.0208 36.9062 18.7292 36.9688 18.4375C37.0312 18.1458 37 17.8438 36.875 17.5312C36.9583 17.5938 37.0208 17.5833 37.0625 17.5C37.1042 17.3958 37.1354 17.2708 37.1562 17.125C37.1771 16.9583 37.1875 16.8021 37.1875 16.6562C37.1875 16.4896 37.1771 16.3542 37.1562 16.25C37.3646 15.7083 37.5312 15.1562 37.6562 14.5938C37.8021 14.0104 37.9271 13.4375 38.0312 12.875C38.1562 12.3125 38.2812 11.7604 38.4062 11.2188C38.5312 10.6771 38.6979 10.1771 38.9062 9.71875C39.1354 9.67708 39.3854 9.70833 39.6562 9.8125C39.9479 9.89583 40.125 10.0104 40.1875 10.1562C40.7292 9.73958 41.2083 9.23958 41.625 8.65625C42.0417 8.05208 42.4688 7.46875 42.9062 6.90625C43.3438 6.34375 43.8229 5.84375 44.3438 5.40625C44.8854 4.96875 45.5625 4.70833 46.375 4.625C46.7917 4.9375 47.25 5.26042 47.75 5.59375C48.2708 5.90625 48.6979 6.32292 49.0312 6.84375C49.1979 6.92708 49.3333 7.02083 49.4375 7.125C49.5625 7.20833 49.7083 7.30208 49.875 7.40625V7.78125C50.125 8.01042 50.3229 8.28125 50.4688 8.59375C50.6354 8.88542 50.7812 9.20833 50.9062 9.5625C51.0312 9.89583 51.1562 10.2396 51.2812 10.5938C51.4062 10.9271 51.5521 11.25 51.7188 11.5625C51.6771 11.6667 51.6562 11.7604 51.6562 11.8438C51.6562 11.9062 51.6667 11.9792 51.6875 12.0625C51.7292 12.1458 51.7604 12.2292 51.7812 12.3125C51.8021 12.3958 51.8021 12.5104 51.7812 12.6562C51.7188 13.5729 51.4167 14.3125 50.875 14.875C50.3542 15.4375 49.7188 15.9062 48.9688 16.2812C48.2188 16.6354 47.4167 16.9375 46.5625 17.1875C45.7083 17.4375 44.9375 17.7083 44.25 18C44.25 18.0833 44.2812 18.125 44.3438 18.125C44.4271 18.125 44.4583 18.1771 44.4375 18.2812C44.9375 18.5938 45.3333 18.8438 45.625 19.0312C45.9167 19.2188 46.1875 19.375 46.4375 19.5C46.7083 19.625 46.9896 19.7396 47.2812 19.8438C47.5938 19.9271 48.0208 20.0312 48.5625 20.1562C49.1042 20.2812 49.5208 20.3854 49.8125 20.4688C50.125 20.5312 50.4062 20.5938 50.6562 20.6562C50.9062 20.6979 51.1562 20.7396 51.4062 20.7812C51.6771 20.8021 52.0521 20.8333 52.5312 20.875C52.7188 21.0625 52.875 21.2917 53 21.5625C53.1458 21.8125 53.2396 22.0729 53.2812 22.3438C53.3229 22.5938 53.3333 22.8438 53.3125 23.0938C53.2917 23.3229 53.2188 23.5104 53.0938 23.6562C53.1146 23.7188 53.1562 23.75 53.2188 23.75C53.3021 23.7292 53.3854 23.7292 53.4688 23.75C53.3438 23.8333 53.2396 23.9375 53.1562 24.0625C53.0729 24.1875 52.9896 24.3125 52.9062 24.4375C52.8229 24.5625 52.7292 24.6667 52.625 24.75C52.5208 24.8542 52.375 24.9167 52.1875 24.9375C51.5417 25.1875 50.7292 25.1979 49.75 24.9688C48.7708 24.7604 47.5312 24.3646 46.0312 23.7812C45.2812 23.4896 44.6667 23.2396 44.1875 23.0312C43.7292 22.8021 43.3229 22.5833 42.9688 22.375C42.6354 22.1458 42.3229 21.9062 42.0312 21.6562C41.7604 21.4062 41.4271 21.1042 41.0312 20.75ZM45.5 10.0312C45.2708 10.3646 45.0104 10.6667 44.7188 10.9375C44.4479 11.2083 44.1771 11.4896 43.9062 11.7812C43.6562 12.0521 43.4271 12.3646 43.2188 12.7188C43.0104 13.0521 42.8646 13.4479 42.7812 13.9062C43.5104 13.8229 44.2708 13.625 45.0625 13.3125C45.8542 12.9792 46.6042 12.6667 47.3125 12.375C47.2292 11.7292 47 11.2083 46.625 10.8125C46.2708 10.4167 45.8958 10.1562 45.5 10.0312ZM70.75 6.40625C70.7708 6.55208 70.7708 6.66667 70.75 6.75C70.75 6.8125 70.7396 6.875 70.7188 6.9375C70.7188 7 70.7188 7.07292 70.7188 7.15625C70.7188 7.21875 70.7396 7.32292 70.7812 7.46875C70.3438 8.17708 69.8333 8.66667 69.25 8.9375C68.6875 9.1875 68.0729 9.375 67.4062 9.5C66.7396 9.60417 66.0521 9.71875 65.3438 9.84375C64.6562 9.96875 63.9688 10.2396 63.2812 10.6562C63.0104 10.5521 62.7604 10.5521 62.5312 10.6562C62.3229 10.7604 62.0104 10.7917 61.5938 10.75C61.4688 10.875 61.3125 10.9688 61.125 11.0312C60.9375 11.0729 60.75 11.125 60.5625 11.1875C60.6458 11.375 60.6771 11.5729 60.6562 11.7812C60.6562 11.9688 60.6875 12.125 60.75 12.25C61.4792 12.3125 62.2812 12.3021 63.1562 12.2188C64.0521 12.1354 64.9271 12.0833 65.7812 12.0625C65.8021 12.1667 65.7917 12.2396 65.75 12.2812C65.7083 12.3021 65.6979 12.3542 65.7188 12.4375C65.8646 12.5417 66.0104 12.6771 66.1562 12.8438C66.3021 12.9896 66.4479 13.1354 66.5938 13.2812C66.7396 13.4271 66.8854 13.5521 67.0312 13.6562C67.1979 13.7396 67.3854 13.7708 67.5938 13.75C67.6771 13.9167 67.7292 14.1042 67.75 14.3125C67.7917 14.5 67.7708 14.6979 67.6875 14.9062C67.3542 15.1354 67.0208 15.375 66.6875 15.625C66.3542 15.8542 66 16.0625 65.625 16.25C65.2708 16.4375 64.8854 16.5938 64.4688 16.7188C64.0729 16.8229 63.625 16.8646 63.125 16.8438C63.0208 16.8438 62.9375 16.8438 62.875 16.8438C62.8333 16.8438 62.7708 16.8125 62.6875 16.75C62.5208 16.8542 62.2812 16.8854 61.9688 16.8438C61.6771 16.8021 61.4479 16.8333 61.2812 16.9375C61.0521 16.8333 60.7708 16.7917 60.4375 16.8125C60.125 16.8125 59.8438 16.7708 59.5938 16.6875C59.2604 17.125 58.9583 17.5938 58.6875 18.0938C58.4167 18.5938 58.1771 19.125 57.9688 19.6875C58.6771 19.7917 59.2604 19.8333 59.7188 19.8125C60.1979 19.7917 60.6458 19.7604 61.0625 19.7188C61.4792 19.6562 61.9062 19.6042 62.3438 19.5625C62.7812 19.5 63.3333 19.4792 64 19.5C64.4167 19.2708 64.9062 19.125 65.4688 19.0625C66.0521 18.9792 66.5833 18.8542 67.0625 18.6875C67.2292 18.75 67.375 18.8646 67.5 19.0312C67.625 19.1771 67.7396 19.3229 67.8438 19.4688C67.9688 19.5938 68.0938 19.7083 68.2188 19.8125C68.3438 19.9167 68.5 19.9583 68.6875 19.9375C68.7708 20.0208 68.8229 20.125 68.8438 20.25C68.8854 20.3542 68.9167 20.4583 68.9375 20.5625C68.9583 20.6667 68.9896 20.7604 69.0312 20.8438C69.0938 20.9062 69.1875 20.9271 69.3125 20.9062C69 21.5938 68.6354 22.125 68.2188 22.5C67.8229 22.8542 67.3646 23.125 66.8438 23.3125C66.3229 23.5 65.7396 23.6458 65.0938 23.75C64.4688 23.8542 63.7708 23.9792 63 24.125C62.8125 24.1667 62.6562 24.1562 62.5312 24.0938C62.4062 24.0521 62.2604 24.0312 62.0938 24.0312C61.6146 24.1354 61.0417 24.2292 60.375 24.3125C59.7083 24.3958 59.0312 24.4271 58.3438 24.4062C57.6562 24.3854 57 24.2917 56.375 24.125C55.75 23.9792 55.2396 23.7083 54.8438 23.3125C54.6771 23.1667 54.5625 23 54.5 22.8125C54.4583 22.6042 54.3229 22.4479 54.0938 22.3438C54.0729 22.0729 54.0312 21.7708 53.9688 21.4375C53.9062 21.1042 53.8438 20.7604 53.7812 20.4062C53.7188 20.0312 53.6667 19.6667 53.625 19.3125C53.6042 18.9583 53.625 18.6354 53.6875 18.3438C53.75 18.0312 53.875 17.75 54.0625 17.5C54.2708 17.25 54.3438 16.9792 54.2812 16.6875C54.3854 16.6667 54.4479 16.6146 54.4688 16.5312C54.4896 16.4271 54.5729 16.3854 54.7188 16.4062C54.8438 16.0312 54.9792 15.6771 55.125 15.3438C55.2708 15.0104 55.4167 14.6875 55.5625 14.375C55.7292 14.0625 55.8854 13.75 56.0312 13.4375C56.1979 13.1042 56.3542 12.7396 56.5 12.3438C56.2083 12.0729 55.9896 11.7812 55.8438 11.4688C55.7188 11.1354 55.625 10.8125 55.5625 10.5C55.5 10.1667 55.4479 9.83333 55.4062 9.5C55.3646 9.14583 55.2917 8.79167 55.1875 8.4375C55.3958 8.125 55.6458 7.875 55.9375 7.6875C56.25 7.47917 56.5833 7.3125 56.9375 7.1875C57.2917 7.0625 57.6771 6.95833 58.0938 6.875C58.5104 6.79167 58.9479 6.69792 59.4062 6.59375C60.2396 6.32292 60.9792 6.11458 61.625 5.96875C62.2917 5.82292 62.9375 5.70833 63.5625 5.625C64.2083 5.52083 64.875 5.42708 65.5625 5.34375C66.25 5.26042 67.0312 5.13542 67.9062 4.96875C68.0938 5.15625 68.2708 5.25 68.4375 5.25C68.5208 5.0625 68.6146 5.01042 68.7188 5.09375C68.8438 5.15625 68.8958 5.09375 68.875 4.90625C69.0833 5.26042 69.3438 5.5625 69.6562 5.8125C69.9896 6.04167 70.3542 6.23958 70.75 6.40625ZM88.4688 21.8125C88.5729 22.4375 88.5312 22.9271 88.3438 23.2812C88.1771 23.6354 87.9271 23.8958 87.5938 24.0625C87.2812 24.25 86.9167 24.3542 86.5 24.375C86.0833 24.3958 85.6875 24.375 85.3125 24.3125C85.1042 24.0208 84.9167 23.6562 84.75 23.2188C84.5833 22.7812 84.4271 22.3333 84.2812 21.875C84.1354 21.3958 84 20.9271 83.875 20.4688C83.7708 20.0104 83.6771 19.6042 83.5938 19.25C83.6979 19 83.7604 18.7188 83.7812 18.4062C83.8229 18.0729 83.8438 17.7396 83.8438 17.4062C83.8646 17.0729 83.875 16.7396 83.875 16.4062C83.8958 16.0521 83.9271 15.7188 83.9688 15.4062C84.1146 14.5312 84.3229 13.6979 84.5938 12.9062C84.8854 12.1146 85.1146 11.2917 85.2812 10.4375C85.3229 10.25 85.3021 10.0729 85.2188 9.90625C85.1562 9.73958 85.1458 9.58333 85.1875 9.4375C85.2083 9.35417 85.2708 9.30208 85.375 9.28125C85.4792 9.23958 85.5417 9.16667 85.5625 9.0625C85.625 8.83333 85.6354 8.64583 85.5938 8.5C85.5729 8.35417 85.6146 8.17708 85.7188 7.96875C85.8229 7.80208 85.9479 7.5625 86.0938 7.25C86.2604 6.91667 86.3229 6.57292 86.2812 6.21875C86.4688 6.09375 86.6458 5.94792 86.8125 5.78125C86.9792 5.61458 87.1458 5.46875 87.3125 5.34375C87.5 5.19792 87.6979 5.07292 87.9062 4.96875C88.1354 4.86458 88.4062 4.8125 88.7188 4.8125C88.8854 5.02083 88.9896 5.25 89.0312 5.5C89.0938 5.75 89.1458 6 89.1875 6.25C89.25 6.5 89.3333 6.73958 89.4375 6.96875C89.5417 7.17708 89.7188 7.34375 89.9688 7.46875C89.9688 7.63542 89.9688 7.84375 89.9688 8.09375C89.9688 8.34375 89.9792 8.59375 90 8.84375C90.0208 9.07292 90.0625 9.29167 90.125 9.5C90.2083 9.6875 90.3333 9.8125 90.5 9.875C90.125 10.875 89.7708 11.8646 89.4375 12.8438C89.125 13.8229 88.8646 14.8125 88.6562 15.8125C88.4479 16.7917 88.3125 17.7812 88.25 18.7812C88.2083 19.7812 88.2812 20.7917 88.4688 21.8125ZM109.875 8.96875C109.354 8.96875 108.792 9.01042 108.188 9.09375C107.583 9.15625 106.99 9.22917 106.406 9.3125C105.99 9.375 105.583 9.42708 105.188 9.46875C104.812 9.51042 104.469 9.54167 104.156 9.5625C104.01 10.0208 103.865 10.4271 103.719 10.7812C103.573 11.1354 103.417 11.4792 103.25 11.8125C103.083 12.1667 102.927 12.5312 102.781 12.9062C102.656 13.2604 102.531 13.6458 102.406 14.0625C102.198 14.3958 102.021 14.7083 101.875 15C101.75 15.2708 101.646 15.5833 101.562 15.9375C101.312 16.25 101.125 16.5833 101 16.9375C100.875 17.2708 100.781 17.5625 100.719 17.8125L100.594 18.1875C100.469 18.3125 100.396 18.4167 100.375 18.5C100.354 18.5625 100.302 18.625 100.219 18.6875C100.198 18.9167 100.125 19.1458 100 19.375C99.9583 19.4792 99.9271 19.5833 99.9062 19.6875C99.8854 19.7708 99.875 19.8333 99.875 19.875C99.875 20.0833 99.8229 20.2188 99.7188 20.2812C99.7396 20.3854 99.7396 20.5 99.7188 20.625C99.6979 20.7292 99.6771 20.8333 99.6562 20.9375C99.5938 21.1875 99.5729 21.3854 99.5938 21.5312C99.6562 21.6146 99.7083 21.6875 99.75 21.75C99.8125 21.8125 99.8542 21.8958 99.875 22C100 22.0833 100.094 22.1354 100.156 22.1562C100.24 22.2188 100.365 22.2917 100.531 22.375L100.812 22.6875C100.917 23.2917 100.823 23.7708 100.531 24.125C100.219 24.5208 99.6875 24.7188 98.9375 24.7188H98.5625C98.4583 24.6146 98.3958 24.5312 98.375 24.4688C98.2083 24.4062 98.0729 24.3542 97.9688 24.3125C97.8646 24.2708 97.7708 24.1875 97.6875 24.0625C97.4167 23.9375 97.1979 23.8333 97.0312 23.75L96.75 23.5938C96.75 23.3646 96.75 23.2396 96.75 23.2188C96.6042 23.0312 96.4896 22.8229 96.4062 22.5938C96.3438 22.3646 96.2917 22.1354 96.25 21.9062C96.2083 21.7188 96.1562 21.5417 96.0938 21.375C96.0521 21.2083 95.9896 21.0625 95.9062 20.9375C95.8646 19.7292 95.9792 18.7083 96.25 17.875C96.5208 17.0417 96.8021 16.2396 97.0938 15.4688C97.2604 15.0521 97.4271 14.6354 97.5938 14.2188C97.7604 13.7812 97.9062 13.3333 98.0312 12.875L98.3125 12.5625C98.4583 12.2292 98.5729 11.9583 98.6562 11.75C98.7604 11.5208 98.8646 11.2917 98.9688 11.0625C99.0312 10.9167 99.0833 10.7812 99.125 10.6562C99.1875 10.5104 99.2396 10.3854 99.2812 10.2812C99.1562 10.2812 99.0417 10.2917 98.9375 10.3125C98.8333 10.3125 98.7292 10.3229 98.625 10.3438C98.5 10.3646 98.3854 10.3854 98.2812 10.4062C98.1771 10.4062 98.0729 10.4062 97.9688 10.4062C97.8229 10.4062 97.7188 10.3958 97.6562 10.375C97.4271 10.4792 97.1771 10.5312 96.9062 10.5312H96.5938C96.5312 10.5312 96.4688 10.5312 96.4062 10.5312C96.3646 10.5104 96.3229 10.5 96.2812 10.5C96.0729 10.5 95.9062 10.5312 95.7812 10.5938C95.5312 10.5938 95.2917 10.5938 95.0625 10.5938H94.75C94.7083 10.5938 94.6562 10.6042 94.5938 10.625C94.5312 10.625 94.4792 10.625 94.4375 10.625C94.2917 10.625 94.1354 10.6146 93.9688 10.5938C93.8021 10.5521 93.625 10.4792 93.4375 10.375C93.1875 10.0417 93.0208 9.86458 92.9375 9.84375L92.6562 9.46875C92.6354 9.34375 92.6042 9.22917 92.5625 9.125C92.5208 9 92.4792 8.86458 92.4375 8.71875C92.3542 8.51042 92.2708 8.29167 92.1875 8.0625C92.125 7.8125 92.0938 7.52083 92.0938 7.1875C92.1146 7.02083 92.1562 6.89583 92.2188 6.8125C92.2812 6.72917 92.3333 6.65625 92.375 6.59375L92.4688 6.125L92.875 6.15625H93.75C94.4167 6.15625 95.0938 6.13542 95.7812 6.09375C96.4688 6.03125 97.1771 5.96875 97.9062 5.90625C98.3229 5.86458 98.7396 5.82292 99.1562 5.78125C99.5938 5.73958 100.042 5.69792 100.5 5.65625C100.583 5.46875 100.667 5.29167 100.75 5.125L101.062 4.96875C101.438 4.94792 101.698 5 101.844 5.125C102.01 5.22917 102.146 5.33333 102.25 5.4375C102.708 5.39583 103.167 5.35417 103.625 5.3125C104.104 5.25 104.583 5.17708 105.062 5.09375C105.771 4.98958 106.479 4.89583 107.188 4.8125C107.917 4.72917 108.615 4.6875 109.281 4.6875C109.573 4.6875 109.854 4.69792 110.125 4.71875C110.396 4.73958 110.646 4.77083 110.875 4.8125L111.188 5.03125C111.25 5.15625 111.333 5.27083 111.438 5.375C111.562 5.47917 111.688 5.58333 111.812 5.6875C112.062 5.91667 112.312 6.1875 112.562 6.5C112.812 6.8125 112.906 7.27083 112.844 7.875C112.677 8.125 112.552 8.27083 112.469 8.3125L112.188 8.6875L111.875 8.65625C111.75 8.65625 111.635 8.67708 111.531 8.71875C111.427 8.73958 111.323 8.77083 111.219 8.8125C111.135 8.85417 111.052 8.89583 110.969 8.9375C110.885 8.95833 110.792 8.97917 110.688 9C110.5 9 110.344 9 110.219 9C110.115 8.97917 110 8.96875 109.875 8.96875ZM125.906 21.8125C126.01 22.4375 125.969 22.9271 125.781 23.2812C125.615 23.6354 125.365 23.8958 125.031 24.0625C124.719 24.25 124.354 24.3542 123.938 24.375C123.521 24.3958 123.125 24.375 122.75 24.3125C122.542 24.0208 122.354 23.6562 122.188 23.2188C122.021 22.7812 121.865 22.3333 121.719 21.875C121.573 21.3958 121.438 20.9271 121.312 20.4688C121.208 20.0104 121.115 19.6042 121.031 19.25C121.135 19 121.198 18.7188 121.219 18.4062C121.26 18.0729 121.281 17.7396 121.281 17.4062C121.302 17.0729 121.312 16.7396 121.312 16.4062C121.333 16.0521 121.365 15.7188 121.406 15.4062C121.552 14.5312 121.76 13.6979 122.031 12.9062C122.323 12.1146 122.552 11.2917 122.719 10.4375C122.76 10.25 122.74 10.0729 122.656 9.90625C122.594 9.73958 122.583 9.58333 122.625 9.4375C122.646 9.35417 122.708 9.30208 122.812 9.28125C122.917 9.23958 122.979 9.16667 123 9.0625C123.062 8.83333 123.073 8.64583 123.031 8.5C123.01 8.35417 123.052 8.17708 123.156 7.96875C123.26 7.80208 123.385 7.5625 123.531 7.25C123.698 6.91667 123.76 6.57292 123.719 6.21875C123.906 6.09375 124.083 5.94792 124.25 5.78125C124.417 5.61458 124.583 5.46875 124.75 5.34375C124.938 5.19792 125.135 5.07292 125.344 4.96875C125.573 4.86458 125.844 4.8125 126.156 4.8125C126.323 5.02083 126.427 5.25 126.469 5.5C126.531 5.75 126.583 6 126.625 6.25C126.688 6.5 126.771 6.73958 126.875 6.96875C126.979 7.17708 127.156 7.34375 127.406 7.46875C127.406 7.63542 127.406 7.84375 127.406 8.09375C127.406 8.34375 127.417 8.59375 127.438 8.84375C127.458 9.07292 127.5 9.29167 127.562 9.5C127.646 9.6875 127.771 9.8125 127.938 9.875C127.562 10.875 127.208 11.8646 126.875 12.8438C126.562 13.8229 126.302 14.8125 126.094 15.8125C125.885 16.7917 125.75 17.7812 125.688 18.7812C125.646 19.7812 125.719 20.7917 125.906 21.8125ZM130.031 9.9375C130.177 9.5 130.406 9.125 130.719 8.8125C131.052 8.5 131.406 8.23958 131.781 8.03125C132.177 7.80208 132.583 7.61458 133 7.46875C133.417 7.32292 133.812 7.19792 134.188 7.09375C135.021 6.73958 135.906 6.40625 136.844 6.09375C137.802 5.76042 138.771 5.46875 139.75 5.21875C140.75 4.96875 141.771 4.8125 142.812 4.75C143.854 4.66667 144.948 4.79167 146.094 5.125C146.156 5.33333 146.25 5.53125 146.375 5.71875C146.5 5.90625 146.625 6.09375 146.75 6.28125C146.896 6.46875 147.021 6.65625 147.125 6.84375C147.229 7.01042 147.292 7.1875 147.312 7.375C147.521 7.5625 147.688 7.77083 147.812 8C147.938 8.20833 147.958 8.48958 147.875 8.84375C147.667 9.01042 147.458 9.16667 147.25 9.3125C147.062 9.4375 146.854 9.55208 146.625 9.65625C145.854 9.46875 145.073 9.40625 144.281 9.46875C143.49 9.53125 142.781 9.58333 142.156 9.625C141.969 9.4375 141.74 9.34375 141.469 9.34375C141.219 9.34375 140.948 9.38542 140.656 9.46875C140.385 9.55208 140.104 9.63542 139.812 9.71875C139.542 9.80208 139.281 9.82292 139.031 9.78125C138.823 9.94792 138.562 10.0625 138.25 10.125C137.958 10.1667 137.635 10.2083 137.281 10.25C137.26 10.3542 137.281 10.4271 137.344 10.4688C137.406 10.4896 137.417 10.5521 137.375 10.6562C137.5 10.8021 137.656 10.9062 137.844 10.9688C138.052 11.0312 138.26 11.0938 138.469 11.1562C138.698 11.2188 138.896 11.3021 139.062 11.4062C139.229 11.4896 139.344 11.6354 139.406 11.8438C139.719 11.8438 139.99 11.9167 140.219 12.0625C140.448 12.2083 140.635 12.3854 140.781 12.5938C140.927 12.8021 141.031 13.0312 141.094 13.2812C141.177 13.5104 141.219 13.7188 141.219 13.9062C141.281 14.0729 141.354 14.1458 141.438 14.125C141.521 14.1042 141.615 14.1458 141.719 14.25C141.781 14.5208 141.938 14.8021 142.188 15.0938C142.438 15.3646 142.635 15.6667 142.781 16C142.823 16.5208 142.854 16.9896 142.875 17.4062C142.896 17.8021 142.823 18.2083 142.656 18.625C142.344 19.3958 141.906 20.0833 141.344 20.6875C140.802 21.2917 140.177 21.8333 139.469 22.3125C138.781 22.7708 138.042 23.1667 137.25 23.5C136.458 23.8333 135.688 24.1146 134.938 24.3438C134.854 24.3229 134.771 24.3229 134.688 24.3438C134.604 24.3646 134.583 24.3125 134.625 24.1875C134.458 24.3333 134.271 24.4271 134.062 24.4688C133.875 24.5104 133.667 24.5208 133.438 24.5C133.208 24.5 132.969 24.4896 132.719 24.4688C132.49 24.4479 132.271 24.4583 132.062 24.5C131.917 24.3542 131.781 24.2083 131.656 24.0625C131.552 23.9375 131.469 23.7708 131.406 23.5625C131.302 23.5625 131.25 23.5104 131.25 23.4062C131.271 23.3021 131.24 23.25 131.156 23.25C131.281 23.0417 131.333 22.9271 131.312 22.9062C131.312 22.8646 131.281 22.8333 131.219 22.8125C131.177 22.7917 131.135 22.7708 131.094 22.75C131.052 22.7083 131.042 22.6562 131.062 22.5938C131.146 22.4271 131.177 22.2396 131.156 22.0312C131.135 21.8021 131.115 21.5729 131.094 21.3438C131.073 21.1146 131.083 20.8958 131.125 20.6875C131.188 20.4792 131.344 20.3125 131.594 20.1875C132.302 20.2708 132.969 20.25 133.594 20.125C134.24 19.9792 134.844 19.7812 135.406 19.5312C135.969 19.2812 136.5 19.0104 137 18.7188C137.521 18.4271 138.031 18.1667 138.531 17.9375C138.594 17.75 138.677 17.5938 138.781 17.4688C138.906 17.3438 139.031 17.2292 139.156 17.125C139.281 17.0208 139.396 16.9062 139.5 16.7812C139.604 16.6562 139.677 16.5 139.719 16.3125C139.74 16.1667 139.698 16.0833 139.594 16.0625C139.51 16.0208 139.469 15.9375 139.469 15.8125L139.125 15.7188C138.729 15.4896 138.281 15.3021 137.781 15.1562C137.281 14.9896 136.854 14.8125 136.5 14.625C136.271 14.75 136.052 14.7812 135.844 14.7188C135.656 14.6562 135.406 14.5938 135.094 14.5312C134.385 14.4896 133.698 14.4167 133.031 14.3125C132.385 14.2083 131.76 14.0208 131.156 13.75C131.115 13.6458 131.062 13.5521 131 13.4688C130.938 13.3854 130.823 13.3646 130.656 13.4062C130.531 13.2396 130.406 13.0833 130.281 12.9375C130.156 12.7708 130.042 12.5938 129.938 12.4062C129.979 12.1562 130.01 11.9479 130.031 11.7812C130.052 11.5938 129.99 11.4167 129.844 11.25C129.927 10.9792 129.99 10.7604 130.031 10.5938C130.073 10.4271 130.073 10.2083 130.031 9.9375ZM153 2.5C153 2.6875 152.969 2.91667 152.906 3.1875C152.865 3.45833 152.823 3.72917 152.781 4C152.74 4.27083 152.729 4.52083 152.75 4.75C152.771 4.95833 152.865 5.09375 153.031 5.15625C152.656 6.26042 152.396 7.1875 152.25 7.9375C152.125 8.6875 152.01 9.40625 151.906 10.0938C151.823 10.7604 151.708 11.4688 151.562 12.2188C151.417 12.9688 151.156 13.8854 150.781 14.9688C150.552 15.6354 150.271 16.1042 149.938 16.375C149.604 16.625 149.25 16.75 148.875 16.75C148.5 16.75 148.115 16.6458 147.719 16.4375C147.323 16.2292 146.958 16 146.625 15.75C146.562 15.3542 146.552 14.875 146.594 14.3125C146.656 13.7292 146.729 13.125 146.812 12.5C146.896 11.875 146.979 11.2812 147.062 10.7188C147.146 10.1354 147.208 9.64583 147.25 9.25C147.458 9.02083 147.604 8.83333 147.688 8.6875C147.771 8.54167 147.823 8.38542 147.844 8.21875C147.885 8.05208 147.917 7.84375 147.938 7.59375C147.958 7.34375 148.01 6.98958 148.094 6.53125C148.135 6.30208 148.115 6.10417 148.031 5.9375C147.969 5.75 147.958 5.57292 148 5.40625C148.042 5.32292 148.104 5.26042 148.188 5.21875C148.292 5.17708 148.354 5.10417 148.375 5C148.458 4.72917 148.479 4.52083 148.438 4.375C148.396 4.20833 148.427 4.01042 148.531 3.78125C148.635 3.61458 148.76 3.35417 148.906 3C149.073 2.625 149.135 2.23958 149.094 1.84375C149.281 1.69792 149.458 1.53125 149.625 1.34375C149.792 1.15625 149.958 0.989583 150.125 0.84375C150.312 0.677083 150.51 0.541667 150.719 0.4375C150.948 0.333333 151.219 0.28125 151.531 0.28125C151.698 0.510417 151.823 0.729167 151.906 0.9375C151.99 1.14583 152.062 1.34375 152.125 1.53125C152.208 1.71875 152.312 1.89583 152.438 2.0625C152.562 2.22917 152.75 2.375 153 2.5ZM149.906 20.2812C149.948 20.4479 149.979 20.6042 150 20.75C150.021 20.8958 150.042 21.0521 150.062 21.2188C149.938 21.6562 149.802 22.0521 149.656 22.4062C149.594 22.5521 149.552 22.6458 149.531 22.6875C149.51 22.7292 149.5 22.7604 149.5 22.7812C149.5 22.8021 149.51 22.8333 149.531 22.875C149.552 22.8958 149.562 22.9792 149.562 23.125L149.406 23.5C149.302 23.6458 149.177 23.7604 149.031 23.8438C148.906 23.9271 148.771 24 148.625 24.0625C148.562 24.1042 148.49 24.1354 148.406 24.1562C148.344 24.1979 148.292 24.2396 148.25 24.2812L148.156 24.6562L147.719 24.7188C147.385 24.8021 147.083 24.8438 146.812 24.8438H146.469C146.219 24.6146 146.021 24.4375 145.875 24.3125C145.729 24.1875 145.562 24.0729 145.375 23.9688C145.146 23.5729 145.01 23.2292 144.969 22.9375C144.927 22.6667 144.875 22.4896 144.812 22.4062L144.375 21.9688L144.75 21.6875L144.375 21.0938C144.625 20.9062 144.812 20.7708 144.938 20.6875C145.062 20.6042 145.167 20.5208 145.25 20.4375C145.354 20.3333 145.458 20.2083 145.562 20.0625C145.667 19.9167 145.833 19.6771 146.062 19.3438L146.344 18.9375L146.719 19.1562C146.823 19.2188 147.01 19.2812 147.281 19.3438C147.573 19.3854 147.823 19.4271 148.031 19.4688C148.365 19.5729 148.688 19.6562 149 19.7188C149.333 19.7604 149.594 19.8646 149.781 20.0312L149.906 20.2812Z"
                        fill="white"
                      />
                      <g clipPath="url(#clip0_1_846)">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M91.4921 43.4384C55.6155 58.8699 46.416 97.0687 51.6191 132.979C51.7073 133.596 51.2773 134.172 50.6576 134.261C50.038 134.35 49.461 133.923 49.3727 133.306C44.0219 96.3908 53.7161 57.2268 90.5981 41.3636C91.1721 41.1153 91.839 41.3795 92.0877 41.9534C92.3357 42.5246 92.0689 43.1894 91.4921 43.4384Z"
                          fill="white"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M50.3973 132.467C51.1198 130.615 52.0008 128.28 52.1085 128.018C55.0278 120.915 58.8958 114.642 63.8169 108.712C64.2157 108.231 64.933 108.163 65.4158 108.559C65.8986 108.955 65.9653 109.669 65.5665 110.151C60.7926 115.899 57.0397 121.982 54.2087 128.872C54.0435 129.273 52.0663 134.523 51.5865 135.555C51.3917 135.98 51.1493 136.16 51.088 136.197C50.7704 136.406 50.478 136.41 50.2537 136.37C50.0008 136.323 49.6027 136.143 49.2979 135.67C48.9809 135.173 48.5802 133.987 48.4547 133.696C46.5497 129.309 44.8077 124.247 42.2433 119.901C39.7981 115.756 36.6011 112.259 31.6775 110.786C31.078 110.607 30.7394 109.974 30.9204 109.377C31.1013 108.779 31.7372 108.44 32.3367 108.619C37.841 110.268 41.4682 114.119 44.201 118.751C46.7497 123.072 48.5123 128.078 50.3973 132.467Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1_846">
                          <rect
                            width="81.8138"
                            height="82.1961"
                            fill="white"
                            transform="matrix(-0.258819 -0.965926 -0.965926 0.258819 115.57 119.025)"
                          />
                        </clipPath>
                      </defs>
                    </svg>

                    <div className="highlightMoment">
                      <video
                        controls
                        className="video"
                        src={story.mediaUrl}
                      ></video>{" "}
                      <div className="bottomArea">
                        <img src={me?.avatar} alt="avatar" />
                        <div className="info">
                          <h4>
                            {me?.first_name} {me?.last_name}
                          </h4>
                          <h5>{moment().format("MMMM DD, YYYY")}</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {step === 3 && (
            <div className="right">
              <div className="white-background">
                <div className="preview">
                  {shareType === "email" && (
                    <div className="highlightArea">
                      <div className="email">
                        <div className="header">
                          <img src={Mark} />
                        </div>

                        <div className="content">
                          <img src={Logo} className="logo" />

                          <h4>Hello, {story.firstName}!</h4>
                          <p>
                            {me.first_name} sent you a message of appreciation!
                          </p>

                          <h4>Here's The Context</h4>
                          <p>
                            {me.first_name} is working on further understanding
                            themselves, who they are, and what is important to
                            them in their career and life. <br />
                            <br />
                            Right now, they are giving thanks to people who have
                            positiviely impacted them.
                          </p>
                          <h4>This is where you come in!</h4>
                          <p>
                            {me.first_name} wants to share how you've helped
                            them. You can view their message by clicking the
                            button below.
                          </p>
                          <button className="btn primary">
                            View {me.first_name}'s Message
                          </button>

                          <div className="share">
                            <h2 className="underline yellow">
                              Spread the love!
                            </h2>
                            <p>
                              With our tool – called Stories – you can send (and
                              receive) thanks to people who’ve had a positive
                              impact on your life. Our tool can help you keep
                              all your nice thank-you messages in one place,
                              which you can come to when you need a little
                              pick-me-up.
                            </p>
                            <img src="https://uploads-ssl.webflow.com/62ebe305459eead40de02ce6/63189dc2f7998576d0e280da_email-storyboard-screens.png" />
                          </div>

                          <button
                            style={{
                              marginTop: "50px",
                            }}
                            className="btn primary"
                          >
                            Send Your Own Thank You Message!
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  {shareType === "link" && (
                    <div className="link">
                      <h3>Invite others to give you their perspective.</h3>
                      <p>
                        Here's your message and link. Share it via text, through
                        DM, or however you'd like!
                      </p>
                      <div className="bubbleContainer">
                        <div className="left">
                          <img
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null; // prevents looping
                              currentTarget.src = `https://placehold.co/100x100?text=${
                                me?.first_name.charAt(0) +
                                me?.last_name.charAt(0)
                              }`;
                            }}
                            src={me.avatar}
                            alt="avatar"
                          />
                        </div>
                        <div className="rightCol">
                          <span>Me</span>
                          <p>
                            {`${story.personalNote}  ${window.location.origin}/story/${story.claimUrl}` ||
                              "E.g Hey Allison, I'm doing some career exploration and could use your perspective! Thank you so much."}
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
